import { coreApi } from '@cp/shared/api/core';
import { ApiServerEntityIDType } from '@cp/utils/apiServer/types';
import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { ApiRoute } from '@common/api/route';
import { generateApiUrl } from '@common/api/configure';

export const coreClientResumeApi = coreApi.injectEndpoints({
  endpoints: (builder) => ({
    getClientResume: builder.query<CatalogItemViewModel, { clientId: ApiServerEntityIDType }>({
      query: (params) => ({
        url: generateApiUrl(ApiRoute.ClientsResumeGet, params),
      }),
    }),
  }),
});
